import React from 'react';

interface TabsProps {
    tabs: string[];
    selectedTab: string;
    onTabChange: (tab: string) => void;
    className?: string;
}

const Tabs = ({
    tabs,
    selectedTab,
    onTabChange,
    className = ''
}: TabsProps) => {
    return (
        <div className={`bg-[#0E0C0C] text-white border-b border-[#616161] rounded-t-2xl ${className}`}>
            <div className="flex gap-8 px-6 pt-4">
                {tabs.map((tab) => (
                    <button
                        key={tab}
                        onClick={() => onTabChange(tab)}
                        className={`pb-2 text-sm relative ${selectedTab === tab
                            ? 'text-white font-medium'
                            : 'text-white/50 hover:text-white'
                            }`}
                    >
                        {tab}
                        {selectedTab === tab && (
                            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-white" />
                        )}
                    </button>
                ))}
            </div>
        </div>
    );
};

export default Tabs; 
